import axios from 'axios';

export interface Chat {
  id: number;
  title?: string | null;
  created_at?: string;
  updated_at?: string;
  messages?: ChatMessage[];
}

export interface ChatMessage {
  content_blocks?: Array<ContentBlock>;
  content?: string;
  contentBlocks?: Array<ContentBlock>;
  created_at?: string;
  id?: number;
  rating: number;
  type: 'assistant' | 'user';
}

export interface ContentBlock {
  content: { text: string; html?: string };
  type: string;
}

export async function indexChats(): Promise<{ chats: Chat[] }> {
  return axios.get(route('api.chats.index')).then((res) => res.data);
}

export async function storeChat(): Promise<{ chat: Chat }> {
  return axios.post(route('api.chats.store')).then((res) => res.data);
}

export async function showChat(chatId: number): Promise<{ chat: Chat }> {
  return axios.get(route('api.chats.show', { chat: chatId })).then((res) => res.data);
}
